import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { get, trim } from 'lodash';
import Ad from '../common/ad';
import SuperSaleCard from '../card/super_sale_card';
import { SUPER_SALE_MODULE_DATA } from '../module/super_sale_data';
import { getTodaysSuperSale } from '../../utils/super_sale';
import { CHANNEL_TAG_SLUG_SHOPPING, EDITION_ID_EN_US } from '../../constants';
import { nodeAttrs } from '../../utils/dom';
import { RIGHT_RAIL_AD_SIZES } from '../../utils/ads/sizes';

const Y_POSITIONS = {
  INITIAL: null,
  TOP: 'top',
  BOTTOM: 'bottom',
  FLOATING: 'floating'
};

const FLOATING_TOP_MARGIN_PX = 80;
const ARTICLE_PADDING_PX = 50;
const SLIDESHOW_PADDING_PX = 0;

export default class RightRailAd extends Component {
  state = {
    yPosition: Y_POSITIONS.INITIAL,
    contentHeight: 1000,
  };

  componentDidMount() {
    window.addEventListener("scroll", this.reposition);
    this.reposition();
    this.setContentHeightBreakpoint();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.reposition);
  }

  reposition = () => {
    const newYPosition = this.getNewYPosition();
    if (this.state.yPosition !== newYPosition) {
      this.setState({
        yPosition: newYPosition,
      });
    }
  };

  setContentHeightBreakpoint() {
    const articleContent = document.getElementById("article-main-content");
    if (articleContent) {
      const contentHeight = articleContent.clientHeight / 2;
      this.setState({ contentHeight });
    }
  }

  hasAdSponsorship = () =>
    trim(get(this.props, "adsState.ad_data.ad_sponsorship", "")).length > 0;

  isShoppingArticle = () => {
    const section_name = get(this.props, "adsState.ad_data.ad_section_name");
    return section_name
      ? section_name.includes(CHANNEL_TAG_SLUG_SHOPPING)
      : false;
  };

  isSlideShowArticle = () => {
    const page_type = get(this.props, "adsState.ad_data.ad_page_type");
    return page_type
      ? page_type.includes("slideshow")
      : false; 
  }

  getNewYPosition() {
    const { targetParentId, slideshow } = this.props;
    const parentNodeAttrs = nodeAttrs(
      targetParentId
        ? document.getElementById(targetParentId)
        : this._containerNode.parentNode
    );

    // This additional offset is a band-aid fix to prevent the ad from moving under the Primis player (which is being inserted onto the page)
    const ADDITIONAL_OFFSET = 230;

    const { top: parentTop } = parentNodeAttrs;
    const padding = slideshow ? SLIDESHOW_PADDING_PX : ARTICLE_PADDING_PX;
    const scrolledAboveFloatArea =
      parentTop - FLOATING_TOP_MARGIN_PX + padding + ADDITIONAL_OFFSET >= 0;

    if (scrolledAboveFloatArea) {
      return Y_POSITIONS.TOP;
    }

    const adNodeAttrs = nodeAttrs(this._adNode);
    const { clientHeight: adHeight } = adNodeAttrs;
    const floatingAdMargin = adHeight + FLOATING_TOP_MARGIN_PX;
    const { bottom: parentBottom } = parentNodeAttrs;

    let scrolledBelowFloatArea =
      parentBottom - floatingAdMargin - ARTICLE_PADDING_PX <= 0;

    const breakpointElement = document.getElementById("content-bottom");
    const article = document.getElementById("editorial-content")
    const rightRailAd = document.getElementById("rr-ad");

    if (!breakpointElement || !article || !rightRailAd) {
      console.error("Required elements not found in the DOM.");
      return;
    }

    // ad should disappear when the user is at the bottom of the article
    // we are using the height of the article and post article ad to determine the stopping point on the article  
    const articleHeight = article.offsetHeight;
    const rightRailAdHeight = rightRailAd.offsetHeight;

    // height of the largest possible ad
    const postArticleAdHeight = 366
    
    if (breakpointElement) {
    // slideshow is handled differently because the height of the article is much shorter
      if (slideshow) {
      const breakpoint = article.getBoundingClientRect().bottom 
      const stoppingPoint = articleHeight - postArticleAdHeight

      scrolledBelowFloatArea = stoppingPoint >= breakpoint     
    } else {
      const breakpoint = article.getBoundingClientRect().top
      const stoppingPoint = postArticleAdHeight - articleHeight + rightRailAdHeight 
      
      scrolledBelowFloatArea = stoppingPoint >= breakpoint     
    }
  }

    if (scrolledBelowFloatArea) {
      return Y_POSITIONS.BOTTOM;
    }

    const scrolledBelowFirstFloat =
      parentBottom - floatingAdMargin - ARTICLE_PADDING_PX <=
      this.state.contentHeight;

    const floatingClasses = [];
    floatingClasses.push(Y_POSITIONS.FLOATING);
    if (scrolledBelowFirstFloat && adHeight > 1) {
      if (adHeight <= 251) {
        floatingClasses.push(Y_POSITIONS.LOW_FLOATING_SM);
      } else {
        floatingClasses.push(Y_POSITIONS.LOW_FLOATING_MD);
      }
    }

    return floatingClasses.join(" ");
  }

  // Only show super sale if index exists and article is a US shopping article and not sponsored
  superSaleCard = () => {
    if (
      this.props.slideshow &&
      this.props.slideIndex === 4 &&
      !this.hasAdSponsorship() &&
      this.isShoppingArticle() &&
      this.context.edition_data.id === EDITION_ID_EN_US
    ) {
      const todaysSuperSale = getTodaysSuperSale(
        SUPER_SALE_MODULE_DATA.rows[0].entities
      );
      return todaysSuperSale;
    }
    return false;
  };

  render = () => (
    <div
      className="right-rail-ad-container"
      ref={(node) => (this._containerNode = node)}
    >
      <div className={`right-rail-floater ${this.state.yPosition}`}>
        {this.superSaleCard() ? (
          <div className="right-rail-super-sale">
            <SuperSaleCard {...this.superSaleCard()} type="slideshow" />
          </div>
        ) : (
          <div className="right-rail-ad" id="rr-ad">
            <Ad
              adsState={this.props.adsState}
              sizes={RIGHT_RAIL_AD_SIZES}
              position="right"
              ref={(node) => (this._adNode = findDOMNode(node))}
              uniqueId="right-rail"
              refreshEveryNSlides={this.props.refreshEveryNSlides}
              refreshOnInterval={this.props.shouldRefreshAdOnInterval}
              useSlideshowAdIntervalRefresher={
                this.props.useSlideshowAdIntervalRefresher
              }
              slideshow={this.props.slideshow}
            />
          </div>
        )}
      </div>
    </div>
  );
}

RightRailAd.propTypes = {
  adsState: PropTypes.object.isRequired,
  shouldRefreshAdOnInterval: PropTypes.bool,
  targetParentId: PropTypes.string,
  refreshEveryNSlides: PropTypes.number,
  slideshow: PropTypes.bool,
  useSlideshowAdIntervalRefresher: PropTypes.bool,
  slideIndex: PropTypes.number,
};

RightRailAd.contextTypes = {
  edition_data: PropTypes.object,
};
